/**
 * Memoized loader for the public 40-category / 127-role Atlas.
 * https://storage.googleapis.com/jobhacki-assets/config/roles.json
 */
import { getRolesFeed } from "@/lib/api";

let cache = null;

export function getRoles() {
  if (cache) return cache;
  cache = (async () => {
    const res = await getRolesFeed();
    if (!res.ok || !res.data) return { categories: [], roles: [] };
    const d = res.data;
    return {
      categories: Array.isArray(d.categories) ? d.categories : [],
      roles: Array.isArray(d.roles) ? d.roles : [],
      salaryDisclaimer: d._salary_disclaimer || "",
    };
  })();
  return cache;
}

/** Slugify any free-text role into a stable URL slug. */
export function slugifyRole(input) {
  return String(input || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
